import { Document } from "../Document";
import { IDocumentAlert } from "../IDocumentAlert";
import { IDocumentValidatable } from "../IDocumentValidatable";
import { DepartmentEmptyAlert } from "../alerts/DepartmentEmptyAlert";

export class DocumentAttributesValidator implements IDocumentValidatable {
  public validate(document: Document): IDocumentAlert[] {
    return document.attributes.department
      ? []
      : [ new DepartmentEmptyAlert() ];
  }
}
